import "./featured.scss";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { CircularProgressbar } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpOutlinedIcon from "@mui/icons-material/KeyboardArrowUpOutlined";
import { useState } from "react";

const Featured = () => {
  const [dailyEarn, setDailyEarn] = useState("")
    const [dailySales, setDailySales] = useState("");
  const [weekEarn, setWeekEarn] = useState("")
    const [monthEarn, setMonthEarn] = useState("");
  
  fetch('http://localhost:8000/order/dailyEarn', {
    method: 'POST',
    headers: {
      'Content-Type':'application/json'
    },
    body:JSON.stringify({})
  }).then((response) => response.json())
    .then((data) => setDailyEarn(data))
  
    fetch("http://localhost:8000/order/dailySales", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({}),
    })
      .then((response) => response.json())
      .then((data) => setDailySales(data));
  
      fetch("http://localhost:8000/order/weekEarn", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({}),
      })
        .then((response) => response.json())
        .then((data) => setWeekEarn(data));
  
        fetch("http://localhost:8000/order/monthEarn", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({}),
        })
          .then((response) => response.json())
          .then((data) => setMonthEarn(data));

  const earnPercentage = ((dailyEarn * 30) / 100) / 10
  const todayPercentage = parseInt(earnPercentage);
  

  
    return (
      <div className="featured">
        <div className="top">
          <h1 className="title">Today Total Revenue</h1>
          <MoreVertIcon fontSize="small" />
        </div>
        <div className="bottom">
          <div className="featuredChart">
            <CircularProgressbar
              value={earnPercentage}
              text={todayPercentage + "%"}
              strokeWidth={5}
            />
          </div>
          <p className="amount">₹{dailyEarn}</p>
          <p className="title">Total sales made today</p>
          <p className="amount">{dailySales}</p>
          <p className="desc">
            Previous transactions processing. Last payments may not be included.
          </p>
          <div className="summary">
            <div className="item">
              <div className="itemTitle">Target</div>
              <div className="itemResult negative">
                <KeyboardArrowDownIcon fontSize="small" />
                <div className="resultAmount">₹{dailyEarn * 2}</div>
              </div>
            </div>
            <div className="item">
              <div className="itemTitle">Last Week</div>
              <div className="itemResult positive">
                <KeyboardArrowUpOutlinedIcon fontSize="small" />
                <div className="resultAmount">₹{weekEarn}</div>
              </div>
            </div>
            <div className="item">
              <div className="itemTitle">Last Month</div>
              <div className="itemResult positive">
                <KeyboardArrowUpOutlinedIcon fontSize="small" />
                <div className="resultAmount">₹{monthEarn}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
};

export default Featured;
